import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "antd";
import { UsersThree } from "@phosphor-icons/react";

import { Badge } from "./ShareWithExpertModalStyled";

/**
 * "This file is being read outside the firm."
 *
 * Sits beside the share action on the matter so the fact is visible
 * without anybody opening a screen to ask. It appears only when there is
 * something to say — a badge reading "not shared" on every file in the
 * firm would be noise, and would be the wrong thing to trust if the
 * request behind it had failed.
 */
const SharedOutsideBadge = ({ count, recipients }) => {
  if (!count) return null;

  const who = recipients
    .map((person) => `${person.name} (${person.organization})`)
    .join(", ");

  return (
    <Tooltip
      title={
        who
          ? `${who}. Anything filed into a shared folder reaches them too.`
          : undefined
      }
    >
      <Badge>
        <UsersThree size={14} />
        {count === 1 && recipients[0]?.name
          ? `Shared with ${recipients[0].name}`
          : `Shared with ${count} outside readers`}
      </Badge>
    </Tooltip>
  );
};

SharedOutsideBadge.propTypes = {
  count: PropTypes.number,
  recipients: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      organization: PropTypes.string,
    })
  ),
};

SharedOutsideBadge.defaultProps = {
  count: null,
  recipients: [],
};

export default SharedOutsideBadge;
